import Sitemap from '~/client/src/shared/models/Sitemap'

import { isPlanDrawable } from '../../MapBoxViewer/globeMapFiles'
import { isPointInRing } from '../../MapBoxViewer/labelGroundTone'

// Where a plan sheet is on the ground, so a label standing on one can be plated.
//
// A casing separates ink from ground by being a different tone to both. On a plan sheet it
// has neither to work with: the paper is white, the linework is black, and 1.5px of
// translucent white between them separates nothing. That is what the plate is for, and this
// is the only question it needs answered — is this label on paper.
//
// Any plan counts. Nothing in the data records whether a sheet is monochrome drafting or a
// colour render, and inferring it would mean reading the image, which is a far larger
// mechanism than the question deserves.

export interface IPlanFootprint {
  // Closed lng/lat ring, in the same shape IGroundFill uses.
  ring: Array<[number, number]>
}

interface ISitemapWithBasemap {
  sitemap?: Sitemap
  basemap?: { source?: string }
}

// Only a plan GlobeViewPlan draws, because a sheet it does not draw is not ground anyone is
// standing on.
export function planFootprints(
  sitemapsWithBasemaps: ISitemapWithBasemap[],
): IPlanFootprint[] {
  const footprints: IPlanFootprint[] = []
  sitemapsWithBasemaps.forEach(plan => {
    if (!isPlanDrawable(plan)) return
    const ring = cornersToRing(plan.sitemap.geoCorners)
    if (ring) footprints.push({ ring })
  })
  return footprints
}

export function isOnPlanSheet(
  lng: number,
  lat: number,
  footprints: IPlanFootprint[],
): boolean {
  return footprints.some(f => isPointInRing(lng, lat, f.ring))
}

// geoCorners is four corners in draw order. Mapbox rejects a non-convex quad, so a simple
// closed ring is faithful — no winding fix needed.
function cornersToRing(
  corners: Array<{ longitude: number; latitude: number }>,
): Array<[number, number]> | null {
  if (!corners || corners.length < 3) return null
  const ring = corners.map(c => [c.longitude, c.latitude] as [number, number])
  ring.push(ring[0])
  return ring
}
